import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';

export interface AssetLite {
  id: string;
  assetId?: string;
}

@Injectable({ providedIn: 'root' })
export class AssetProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/asset';

  filterByType(assetTypeReference: string): Observable<ApiResponse<AssetLite[]>> {
    return this.httpClient.post<ApiResponse<AssetLite[]>>(`${this.baseUrl}/filter`, { assetTypeReference });
  }
}
